import { fbDB } from "../config/firebase";
import { QUIZ4_DATA_WATCH, QUIZ4_DATA_UPDATE, QUIZ4_META_WATCH } from "./types";

export const quiz4DataWatch = () => async dispatch => {
  fbDB.ref(`/activities/quizzes/data/quiz4`).on("value", snapshot => {
    return dispatch({
      type: QUIZ4_DATA_WATCH,
      payload: {
        data: snapshot.val()
      }
    });
  });
};

export const quiz4DataUpdate = (idx, data) => async dispatch => {
  fbDB
    .ref(`/activities/quizzes/data/quiz4/${idx}`)
    .update({
      ...data
    })
    .then(() => {
      return dispatch({
        type: QUIZ4_DATA_UPDATE,
        payload: null
      });
    })
    .catch(err => {
      console.log(err);
    });
};

export const quiz4MetaWatch = () => async dispatch => {
  fbDB.ref(`/activities/quizzes/meta/quiz4`).on("value", snapshot => {
    return dispatch({
      type: QUIZ4_META_WATCH,
      payload: {
        meta: snapshot.val()
      }
    });
  });
};
